import { render, staticRenderFns } from "./AccettazionePrestazioniAppuntamentiAccessiListPage.vue?vue&type=template&id=eb8ced36&scoped=true"
import script from "./AccettazionePrestazioniAppuntamentiAccessiListPage.vue?vue&type=script&lang=js"
export * from "./AccettazionePrestazioniAppuntamentiAccessiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8ced36",
  null
  
)

export default component.exports